import { FC } from 'react';

import { useFormikContext } from 'formik';
import { compact } from 'lodash';
import { Button } from 'ui/components/common';
import { TagsField } from 'ui/components/form';
import useModal from 'ui/partials/Modal/useModal';
import { cn } from 'utils/helpers';

import { MULTI_DEALS_EDIT_FORM } from './schema';

const MultiDealsEditForm: FC = () => {
  const { hideModal } = useModal();

  const {
    values,
    handleSubmit,
    setFieldError,
    setFieldValue,
    setErrors,
    isSubmitting,
  } = useFormikContext<MULTI_DEALS_EDIT_FORM>();

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-y-4">
        <p className="text-xs">
          Note: this will override the tags of all selected deals
        </p>
        <TagsField
          className="col-span-4 w-full"
          onChange={(val) =>
            setFieldValue(
              'tagId',
              val?.map((tag) => tag.value),
            )
          }
          defaultValue={compact(values.tagId)}
          setError={(err) => {
            if (err) {
              setFieldError(
                'tagId',
                'Tags cannot have spaces and special characters.',
              );
            } else {
              setErrors({});
            }
          }}
        />
      </div>
      <div
        className={cn(
          'mt-5 pt-5',
          'flex gap-3 justify-end',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        <Button
          onClick={hideModal}
          type="button"
          disabled={isSubmitting}
          label="CANCEL"
          intent="tertiary"
          size="sm"
        />
        <Button disabled={isSubmitting} label="SAVE" type="submit" size="sm" />
      </div>
    </form>
  );
};

export default MultiDealsEditForm;
